import { render, staticRenderFns } from "./VfAutoSelect.vue?vue&type=template&id=1e0e7aca&scoped=true"
import script from "./VfAutoSelect.vue?vue&type=script&lang=js"
export * from "./VfAutoSelect.vue?vue&type=script&lang=js"
import style0 from "./VfAutoSelect.vue?vue&type=style&index=0&id=1e0e7aca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e0e7aca",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VChip } from 'vuetify/lib/components/VChip';
installComponents(component, {VAutocomplete,VChip})
